<div class="p-grid">
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'user-crown']"></fa-icon>
				</span>
				<span class="overview-title">Outstanding Balance</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						<span *ngIf="outstandingBalance">
							{{ outstandingBalance | currency }}
						</span>
						<p-skeleton *ngIf="!outstandingBalance"></p-skeleton>
					</div>
					<div class="overview-subtext">Total outstanding gift card balance</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'user-crown']"></fa-icon>
				</span>
				<span class="overview-title">Total Cards Issued</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						{{ cardCount | number }}
					</div>
					<div class="overview-subtext">Cards issued</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'user-crown']"></fa-icon>
				</span>
				<span class="overview-title">Last Transaction</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						<p-skeleton *ngIf="!lastTransaction"></p-skeleton>
						<span *ngIf="lastTransaction">
							{{ lastTransaction.AcctNo }}
						</span>
					</div>
					<div class="overview-subtext">
						<span *ngIf="lastTransaction">{{ lastTransaction.TranCode }}&nbsp;{{ lastTransaction.Authorize | currency }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
